import React, {
  useEffect,
  useState,
  useContext,
  Fragment,
  useRef,
} from "react";
import { useNavigate } from "react-router-dom";
import { Divider, ListSubheader } from "@mui/material";
import { Checkbox } from "@mui/material";
import { useParams } from "react-router-dom";
import Calendar from "./Calendar";
import ClientFilingMasterContext from "../../context/client-filing-master/ClientFilingMasterContext";
import usePermission from "../../usePermission";
import axios from "axios";
import Toolbox from "./Toolbox";
import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import ClientFilingTrackerComments from "../client-filing-tracker/ClientFilingTrackerComments";
import ClientFilingTrackerAttachment from "../client-filing-tracker/ClientFilingTrackerAttachments";
import CustomDialog from "../common/CustomDialog";
import { Button as PrimeButton } from "primereact/button";
import { Button, InputLabel } from "@mui/material";
import { TextField, MenuItem, Select, Box } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import Popover from "@mui/material/Popover";
import IconButton from "@mui/material/IconButton";
import ClientFilingTrackerHistory from "../client-filing-tracker/ClientFilingTrackerHistory";
import ClientFilingTrackerDocuments from "../client-filing-tracker/ClientFilingTrackerDocuments";
import ClientFilingConsolidatedUpdate from "../client-filing-tracker/ClientFilingConsolidatedUpdate";
import AuthContext from "../../context/auth/AuthContext";
import useDialog from "../common/UseDialog";
import FilingMasterContext from "../../context/filing-master/FilingMasterContext";
import { Typography } from "@mui/material";
import CustomerContext from "../../context/customer/CustomerContext";
import CalendarDetailsDialog from "./CalendarDetailsDialog";
import ClientFilingBulkStatusUpdate from "../client-filing-tracker/ClientFilingBulkStatusUpdate";
import { DateTime } from "luxon";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { MultiSelect } from "primereact/multiselect";
import Stack from "@mui/material/Stack";
import { tokens } from "../../theme/tokens";
import { NoticeIllustration } from "../common/DialogIllustrations";
import { useCommonDetailsContext } from "../../context/Common/common";

import {
  fetchCalendarEventDetails,
  syncCalendarEventPeriodDueDate,
  updateCalendarEventDetails,
} from "./CalendarDetailsDialog/helper";
import html2pdf from "html2pdf.js";
import states from "../../data/StateLookup.json";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { TrackNowButton } from "../ui";
const StyledDivider = styled(Divider)({
  '&.MuiDivider-root': {
    lineHeight: '25px',
  },
});

const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const TrackerCalendarView = ({ onAddClientSpecificFilingClick }) => {
  const { publishedBranding, clientScopedBranding, setClientScopedBranding, validateParentData, fetchClientBranding } = useCommonDetailsContext();
  const activeBranding = validateParentData?.isSingleParent ? publishedBranding : (clientScopedBranding || publishedBranding);
  const primaryColor = activeBranding?.primaryColor || tokens.colors.connectedPurple;
  const { clientId } = useParams();
  const navigate = useNavigate();

  const [selectedClientId, setSelectedClientId] = useState(clientId);
  const customerContext = useContext(CustomerContext);
  const { getCustomers, customers, selectedCustomer } = customerContext || {};

  useEffect(() => {
    const targetId = selectedClientId || clientId;
    if (!validateParentData?.isSingleParent && targetId && fetchClientBranding) {
      const customerList = customers || [];
      const selected = customerList.find((c) => String(c.customerId) === String(targetId)) || (String(selectedCustomer?.customerId) === String(targetId) ? selectedCustomer : null);
      const customerType = selected?.customerType || selected?.clientType;
      fetchClientBranding(targetId, customerType);
    } else if (!targetId && setClientScopedBranding) {
      setClientScopedBranding(null);
    }
  }, [selectedClientId, clientId, validateParentData?.isSingleParent, fetchClientBranding, setClientScopedBranding, customers, selectedCustomer]);
  const [
    selectedTrackerCalendarEventExtract,
    setSelectedTrackerCalendarEventExtract,
  ] = useState([]);
  const [
    selectedTrackerCalendarEventDetails,
    setSelectedTrackerCalendarEventDetails,
  ] = useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [currentCalenderEvents, setCurrentCalenderEvents] = useState();
  const [isSticky, setIsSticky] = useState(false);
  const [currentEvent, setCurrentEvent] = useState({
    statDate: null,
    endDate: null,
  });

  const [isRefreshCalender, setIsRefreshCalender] = useState(false);
  const [showRadio1, setShowRadio1] = useState(false);
  const [isPostAwardAccess, setIsPostAwardAccess] = useState(false);
  const [isTrackNowAccess, setIsTrackNowAccess] = useState(false);

  const hasAddClientFilingPermission = usePermission(
    "ClientFilingList",
    "addFiling",
    selectedClientId || clientId
  );

  const canAddClientFiling = Boolean(
    hasAddClientFilingPermission !== false &&
    (
      (Number(selectedCustomer?.trackNowLicenseId) > 0 && isTrackNowAccess) ||
      (Number(selectedCustomer?.postAwardLicenseId) > 0 && isPostAwardAccess)
    )
  );
  const isAddClientFilingDisabled = !canAddClientFiling;
  const [customerNames, setCustomerNames] = React.useState([]);
  const [affectedCompanyLists, setAffectedCompanyLists] = React.useState([]);
  const [selectedAffectedCompanies, setSelectedAffectedCompanies] =
    React.useState([]);
  const [isCompanySelectOpen, setIsCompanySelectOpen] = useState(false);
  const [isCompanySelectEditOpen, setIsCompanySelectEditOpen] = useState(false);
  const [selectedAffectedCompaniesEdit, setSelectedAffectedCompaniesEdit] =
    React.useState([]);
  const [affectedCompanyListsDropdown, setAffectedCompanyListsDropdown] =
    React.useState([]);
  const [showRadioEdit, setShowRadioEdit] = useState(false);
  const [
    selectedAffectedCompaniesEditInitial,
    setSelectedAffectedCompaniesEditInitial,
  ] = React.useState([]);
  const [
    selectedAffectedCompaniesEditInitialNames,
    setSelectedAffectedCompaniesEditInitialNames,
  ] = React.useState([]);

  const [showComments, setShowComments] = useState(false);
  const [comments, setComments] = React.useState([]);

  const [showAttachments, setShowAttachments] = useState(false);
  const [attachments, setAttachments] = React.useState([]);

  const [showHistory, setShowHistory] = useState(false);
  const [activityHistory, setActivityHistory] = React.useState([]);
  const [clientActivityHistory, setClientActivityHistory] = React.useState([]);
  const [commentActivityHistory, setCommentActivityHistory] = React.useState(
    []
  );
  const [radioMessage1, setRadioMessage1] = useState(
    "Which record type do you want to create?"
  );
  const [radioVal1, setRadioVal1] = React.useState("tracknow");
  const [isTnistoryLoading, setIsTnHistoryLoading] = useState(true);
  const [isCfHistoryLoading, setIsCfHistoryLoading] = useState(true);
  const [isCommentsHistoryLoading, setIsCommentsHistoryLoading] =
    useState(true);

  const [showDocuments, setShowDocuments] = useState(false);
  const [documents, setDocuments] = React.useState([]);

  const [consolidatedRecords, setConsolidatedRecords] = React.useState([]);
  const [consolidatedStatus, setConsolidatedRecordsStatus] = React.useState([]);
  const [showConsolidated, setShowConsolidated] = useState(false);
  const [staffList, setStaffList] = React.useState([]);

  const [commonStaffs, setCommonStaffs] = useState([]);
  const [bulkUpdateRecords, setBulkUpdateRecords] = useState([]);
  const [showBulkStatusDrawer, setShowBulkStatusDrawer] = useState(false);

  const [isDeleteClientFiling, setIsDeleteClientFiling] = useState(false);

  const [calendarEventList, setCalendarEventList] = useState([]);
  const [openCalendarDetails, setOpenCalendarDetails] = useState(false);
  const [dragDropConfig, setDragDropConfig] = useState(null);
  const [calConfig, setCalConfig] = useState({
    startDate: null,
    endDate: null,
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const openFilter = Boolean(anchorEl);
  const [isSearch, setIsSearch] = useState(false);
  const [searchConfig, setSearchConfig] = useState({
    searchBy: "",
    searchType: "",
    searchVal: "",
  });
  const [currentCalendarYear, setCurrentCalendarYear] = useState(null)
  const clientFilingMasterContext = useContext(ClientFilingMasterContext);
  const {
    selectedTrackerCalendarEvent,
    setSelectedTrackerCalendarEvent,
    setSelectedTrackerCalendarEventDisplay,
    selectedTrackerCalendarEventDisplay,
    getClientFilingTrackerComments,
    getClientFilingTrackerAttachments,
  } = clientFilingMasterContext;
  const authContext = useContext(AuthContext);
  const { authUser, userRoles, roleType } = authContext;
  const filingMasterContext = useContext(FilingMasterContext);
  const {
    setCurrentFilingMaster,
    deleteDraftFilingMaster,
    createFilingMasterWorkflow,
  } = filingMasterContext;


  const getDefaultCreateRecordType = (customer = selectedCustomer) => {
    if (Number(customer?.trackNowLicenseId) > 0) {
      return "tracknow";
    }

    if (Number(customer?.postAwardLicenseId) > 0) {
      return "postaward";
    }

    return "tracknow";
  };

  const getAffectedCompaniesByRecordType = (
    companies = [],
    recordType = "tracknow"
  ) => {
    const licenseKey =
      recordType === "postaward" ? "postAwardLicenseId" : "trackNowLicenseId";

    return companies.filter((company) => Number(company?.[licenseKey]) > 0);
  };

  const resetCreateDialogState = (
    recordType = getDefaultCreateRecordType(),
    companies = affectedCompanyLists
  ) => {
    setSelectedAffectedCompanies([]);
    setSelectedAffectedCompaniesEdit([]);
    setCustomerNames([]);
    setSelectedAffectedCompaniesEditInitial([]);
    setSelectedAffectedCompaniesEditInitialNames([]);
    setRadioVal1(recordType);
    setAffectedCompanyListsDropdown(
      getAffectedCompaniesByRecordType(companies, recordType)
    );
  };

  const openCreateRecordDialog = (companies = affectedCompanyLists) => {
    resetCreateDialogState(getDefaultCreateRecordType(), companies);
    setShowRadio1(true);
  };

  // const handleEventSelect = (val) => {
  //   setSelectedTrackerCalendarEvent(val);
  //   setOpenCalendarDetails(true);
  // };

  const handleCalendarDetailsClose = () => {
    setOpenCalendarDetails(false);
    setSelectedTrackerCalendarEventDisplay();
    setSelectedTrackerCalendarEvent([]);
  };

  const checkExsistingData = (startDate, endDate, isRefresh) => {
    // console.log("checkExsistingData props", startDate, endDate, calConfig);

    if (
      calConfig.startDate === null &&
      calConfig.startDate === null &&
      !isRefresh
    ) {
      return { isExist: false, direction: null };
    }

    const newStartDate = new Date(startDate).setHours(0, 0, 0, 0);
    const newEndDate = new Date(endDate).setHours(0, 0, 0, 0);

    const oldStartDate = new Date(calConfig.startDate).setHours(0, 0, 0, 0);
    const oldEndDate = new Date(calConfig.endDate).setHours(0, 0, 0, 0);

    // console.log(
    //   "checkExsistingData date",
    //   newStartDate < oldStartDate,
    //   newEndDate > oldEndDate
    // );
    if (newStartDate < oldStartDate || newEndDate > oldEndDate) {
      return {
        isExist: false,
        direction: newEndDate > oldEndDate ? "forward" : "backward",
      };
    }

    // console.log("checkExsistingData exist");

    return { isExist: true, direction: null };
  };

  const toLocalTime = (date) => {
    if (date) {
      const _date = DateTime.fromFormat(
        DateTime.fromISO(date.toString()).toFormat("dd-LL-yyyy hh:mm:ss"),
        "dd-LL-yyyy hh:mm:ss",
        { zone: "UTC" }
      ).toFormat("dd-LL-yyyy");
      // console.log("@@@ LocalllTime:", _date);

      return _date;
    } else return "";
  };

  const handleSearch = () => {
    console.log("handleSearch", searchConfig);
    setIsSearch(true);
    fetchCalendarEvents(currentCalenderEvents, true);
    setAnchorEl(null);
  };

  const handleCancelSearch = () => {
    console.log("handleCancelSearch", searchConfig);
    setSearchConfig({
      searchBy: "",
      searchType: "",
      searchVal: "",
    });
    setIsSearch(false);
    fetchCalendarEvents(currentCalenderEvents, true, true);
    setAnchorEl(null);
  };

  const fetchCalendarEvents = async (props, isRefresh, isClearSearch) => {
    // console.log("fetchCalendarEvents props", props);
    // console.log("fetchCalendarEvents currentEvent", currentEvent);

    let startDate;
    let endDate;

    if (isRefresh) {
      startDate = currentEvent.statDate;
      endDate = currentEvent.endDate;
    } else {
      startDate = props?.startStr?.split("T")[0];
      endDate = props?.endStr?.split("T")[0];
    }
    if (props) {
      setCurrentEvent({ statDate: startDate, endDate: endDate });
    }
    // console.log("fetchCalendarEvents date", startDate, endDate);
    if (startDate === undefined || startDate === undefined) {
      return;
    }

    let checkData = checkExsistingData(startDate, endDate, isRefresh);
    // console.log("fetchCalendarEvents checkData", checkData);

    if (!checkData.isExist || isRefresh) {
      if (props) {
        setCurrentCalenderEvents(props);
      }

      let url = `${API_BASE_URL}/CalenderView/Tracker/FilingNames?CustomerId=${selectedClientId}&StartDate=${startDate}&EndDate=${endDate}`;

      if (
        searchConfig.searchBy !== "" &&
        searchConfig.searchType !== "" &&
        !isClearSearch && (searchConfig.searchVal !== "" ||
          (searchConfig.searchVal === "" && ["Federal", "Both"].includes(searchConfig.searchBy)))
      ) {
        //Truthy check
        //1. All field(searchConfig.searchBy,searchConfig.searchType and searchConfig.searchVal) should have value
        //2. searchConfig.searchVal can be "" incase searchConfig.searchBy has either Federal or Both
        const searchValForJurisdiction = {
          searchBy: (searchConfig.searchBy === "Federal" || searchConfig.searchBy === "Both") ? "Juristiction" : searchConfig.searchBy,
          searchVal: searchConfig.searchBy === "Federal" ? "Federal" : searchConfig.searchBy === "Both" ? "Both" : searchConfig.searchVal
        }
        console.log("API searchConfig", searchConfig);

        url = `${url}&SearchBy${searchValForJurisdiction.searchBy}=${searchValForJurisdiction.searchVal}&${searchValForJurisdiction.searchBy}SearchType=${searchConfig.searchType}`;
      }

      let res = await axios.get(url);
      // console.log("fetchCalendarEvents res", res);
      let eventList = res.data.data.map((ele) => ({
        ...ele,
        id: ele.fileTrackingId,
        title: ele.filingName,
        date: ele.filingDueDate.split("T")[0],
      }));

      if (checkData.direction === "forward") {
        setCalendarEventList([...calendarEventList, ...eventList]);
        setCalConfig({ ...calConfig, endDate: endDate });
      } else if (checkData.direction === "backward") {
        setCalendarEventList([...eventList, ...calendarEventList]);
        setCalConfig({ ...calConfig, startDate: startDate });
      } else {
        setCalendarEventList(eventList);
        setCalConfig({ startDate, endDate });
      }
    }
  };

  const getStaffList = () => {
    const staffListFilt = userRoles
      .filter((ele) => {
        if (ele.roleName === "Admin" || ele.roleName === "Admin-PostAward") {
          return ele;
        } else if (parseInt(clientId) === ele.customerId) {
          return ele;
        }
      })
      .filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.userName === value.userName)
      );
    staffListFilt.sort(function (a, b) {
      if (a.userName < b.userName) {
        return -1;
      }
      if (a.userName > b.userName) {
        return 1;
      }
      return 0;
    });
    // console.log("fetchStaffAssigned staffListFilt", staffListFilt);
    setStaffList(staffListFilt);
  };

  const handleDragAndDropEvent = (val, oldVal) => {
    setDragDropConfig({ val, oldVal });
    setSelectedTrackerCalendarEventDisplay(val);
    showDragDropDialog(
      "Confirmation",
      <Typography>
        Are you sure you want to move{" "}
        <Typography fontWeight="bold" component="span">
          {val.filingName}
        </Typography>
        ?
      </Typography>,
      "confirm"
    );
  };

  const dragAndDropEvent = async () => {
    try {
      const updatedEvent = await fetchCalendarEventDetails(
        selectedTrackerCalendarEventDisplay.id,
        selectedClientId,
        currentCalendarYear

      );
      let date = new Date(selectedTrackerCalendarEventDisplay.startStr);
      updatedEvent[0].filingDueDate = date;
      // console.log("handleDragAndDropEvent updatedEvent", date, updatedEvent);
      const res = await updateCalendarEventDetails(updatedEvent);
      await syncCalendarEventPeriodDueDate(updatedEvent[0].fileTrackingId);
      console.log("handleDragAndDropEvent res", res);
      if (res) {
        fetchCalendarEvents(currentCalenderEvents, true);
        setAlertMessage("Filing has been successfully updated");
        setShowAlert(true);
      }
    } catch (err) {
      console.log("handleDragAndDropEvent err", err);
      setAlertMessage("Error while updating filing");
      setShowAlert(true);
    }
  };

  const closeDragDropConfirm = () => {
    // console.log("closeDragDropConfirm", dragDropConfig.oldVal);

    let prevCalendarList = calendarEventList.map((ele) => {
      if (
        ele.id === dragDropConfig.oldVal["_def"].extendedProps.fileTrackingId
      ) {
        return dragDropConfig.oldVal["_def"].extendedProps;
      }
      return ele;
    });

    prevCalendarList = prevCalendarList.map((ele) => ({
      ...ele,
      id: ele.fileTrackingId,
      title: ele.filingName,
      date: ele.filingDueDate.split("T")[0],
    }));
    setCalendarEventList(prevCalendarList);
    setSelectedTrackerCalendarEventDisplay(dragDropConfig.oldVal);
  };

  //Delete filings
  const {
    AlertDialog: ConfirmDragDropDialog,
    showDialog: showDragDropDialog,
    closeDialog: closeDragDropDialog,
  } = useDialog({
    onSubmit: () => dragAndDropEvent(),
    onClose: closeDragDropConfirm,
  });

  const checkPastDueDate = (filingDueDate) => {
    const dueDate = new Date(filingDueDate);
    return dueDate < new Date();
  };

  const generateCalendarHtml = () => {
    const start = new Date(currentCalenderEvents.view.activeStart);
    const end = new Date(currentCalenderEvents.view.activeEnd);

    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    let calendarHtml =
      "<table border='1' style='width: 100%; border-collapse: collapse; font-size: 12px; margin: 0; table-layout: fixed;'>";

    // Only show day headers if there's more than one day
    const timeDiff = end - start;
    if (timeDiff !== 86400000) {
      calendarHtml += "<thead><tr>";
      daysOfWeek.forEach((day) => {
        calendarHtml += `<th style="padding: 10px; text-align: center; font-weight: bold;">${day}</th>`;
      });
      calendarHtml += "</tr></thead><tbody><tr>";
    } else {
      calendarHtml += "<tbody><tr>";
    }

    let currentMonth = start.getMonth();
    let currentYear = start.getFullYear();
    let col = start.getDay(); // Start from the correct day (Sunday-Saturday)

    let currentDate = new Date(start); // Start from the 'start' date

    // Loop through each date between start and end dates
    while (currentDate < end) {
      if (col === 7) {
        col = 0;
        calendarHtml += "</tr><tr>"; // New row after 7 columns (Sunday-Saturday)
      }

      const day = currentDate.getDate();
      const dayString = `${currentYear}-${String(currentMonth + 1).padStart(
        2,
        "0"
      )}-${String(day).padStart(2, "0")}`;

      // Debugging log for checking the date format
      console.log("Checking events for day:", dayString);

      const dayEvents = calendarEventList.filter(
        (event) => event.date === dayString
      );

      // Create the day cell with equal width (14.28% of the total table width)
      calendarHtml += `<td style="vertical-align: top; text-align: right; height: 60px; padding: 10px; position: relative; width: 14.28%;">${day}`;

      // Add events for the day
      if (dayEvents.length > 0) {
        dayEvents.forEach((event) => {
          const status = event.status;
          const isPastDueDate = checkPastDueDate(event.filingDueDate);
          let backgroundColor = "rgb(79, 70, 229)"; // Default color

          if (status === "Completed") {
            backgroundColor = "#28a745"; // Green for Completed status
          } else if (isPastDueDate) {
            backgroundColor = "#dc3545"; // Red for past due dates
          }

          const fontStyle = event.isMasterFiling ? "normal" : "italic";
          const fontWeight = event.isMasterFiling ? "normal" : "bold";

          // Display event with styling
          calendarHtml += `
            <span style="display: block; background-color: ${backgroundColor}; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: white; margin: 2px 0; padding: 2px 5px; border: 1px solid #4f46e5; width: 100%; text-align: left;">
              ${event.title}
            </span>
          `;
        });
      }

      calendarHtml += "</td>";

      // Move to the next day
      currentDate.setDate(currentDate.getDate() + 1);
      col++;

      // Check if the day exceeds the number of days in the current month
      if (currentDate.getDate() === 1) {
        // If it's the 1st day of the next month, move to the next month
        currentMonth = currentDate.getMonth();
        currentYear = currentDate.getFullYear();
      }
    }

    // If it's the end of the month and we have leftover empty cells, fill them with empty <td> tags
    while (col < 7) {
      calendarHtml += "<td></td>";
      col++;
    }

    calendarHtml += "</tr></tbody></table>";
    return calendarHtml;
  };

  const generatePdf = () => {
    console.log("generatePdf", currentCalenderEvents);
    const doc = new jsPDF("landscape", "mm", "a4");

    doc.setFontSize(20);
    doc.text(currentCalenderEvents.view.title, 10, 20);

    const calendarHtml = generateCalendarHtml();
    doc.html(calendarHtml, {
      callback: function (doc) {
        doc.save(`calendar ${currentCalenderEvents.view.title}.pdf`);
      },
      x: 10,
      y: 30,
      width: 280,
      windowWidth: 1000,
      margin: [0, 0, 0, 0],
      autoPaging: true,
    });
  };

  //close Attachment
  const closeAttachments = () => {
    setShowAttachments(() => false);
  };

  //Close comments
  const closeComments = () => {
    setShowComments(() => false);
  };
  const closeAlert = () => {
    setShowAlert(false);
  };
  //close history
  const closeHistory = () => {
    setShowHistory(() => false);
  };
  //close reference docs
  const closeDocuments = () => {
    setShowDocuments(() => false);
  };
  //close consolidated
  const closeConsolidated = () => {
    setShowConsolidated(() => false);
  };
  const closeConfirm = () => { };
  const closeStatusBulkUpdateDrawer = () => {
    setBulkUpdateRecords([]);
    setShowBulkStatusDrawer(() => false);
    setSelectedTrackerCalendarEvent([]);
    setSelectedTrackerCalendarEventDetails([]);
    setSelectedTrackerCalendarEventExtract([]);
  };
  const radioCloseAlert1 = () => {
    resetCreateDialogState();
    setShowRadio1(false);
  };
  const radioCloseAlertEdit = () => {
    setSelectedAffectedCompanies([]);
    setSelectedAffectedCompaniesEdit([]);
    setSelectedAffectedCompaniesEditInitial([]);
    setSelectedAffectedCompaniesEditInitialNames([]);
    setShowRadioEdit(false);
    setCustomerNames([]);
  };
  //Get attachment
  const getAttachment = async (customerId, fileTrackingId, commentsId) => {
    const res = await axios.get(
      `${API_BASE_URL}/Customer/CustomerFilingTrackingCommentsAttachments?customerId=${customerId}&fileTrackingId=${fileTrackingId}&commentsId=${commentsId}`
    );

    if (res.data) {
      return {
        attachmentPath: res.data.data[0].attachmentPath,
        attachmentId: res.data.data[0].attachmentId,
      };
    }
  };

  //Attachemnt API
  const fetchClientFilingTrackerAttachments = async (fileTrackingId) => {
    if (getClientFilingTrackerAttachments) {
      try {
        const attachmentList = await getClientFilingTrackerAttachments(
          fileTrackingId
        );
        setAttachments(() => attachmentList);
      } catch (error) { }
    }
  };

  //Add Attachments
  const displayAttachments = async () => {
    if (
      selectedTrackerCalendarEventExtract &&
      selectedTrackerCalendarEventExtract[0]?.fileTrackingId
    ) {
      if (selectedTrackerCalendarEventExtract.length > 1) {
        setAlertMessage("Please Select single Filing Tracker Record");
        setShowAlert(true);
      } else {
        setShowAttachments(() => true);
        const selectedEventDeails = await getSelectedEventDetails();
        fetchClientFilingTrackerAttachments(
          selectedEventDeails[0]?.fileTrackingId
        );
      }
    } else {
      setAlertMessage("Please Select a Filing Tracker Record");
      setShowAlert(true);
    }
  };

  //Add comments api
  const fetchClientFilingTrackerComments = async (
    fileTrackingId,
    customerId
  ) => {
    if (getClientFilingTrackerComments) {
      try {
        let commentList = await getClientFilingTrackerComments(fileTrackingId);
        commentList = await Promise.all(
          commentList.map(async (ele) => {
            const { attachmentPath, attachmentId } = await getAttachment(
              customerId || selectedTrackerCalendarEventExtract[0].customerId,
              ele.fileTrackingId,
              ele.commentsId
            );
            ele.attachmentPath = attachmentPath;
            ele.attachmentId = attachmentId;
            return ele;
          })
        );
        setComments(() => commentList);
      } catch (error) {
        console.log("@@Error:", error);
      }
    }
  };
  //Add comments
  const addComment = async () => {
    if (selectedTrackerCalendarEventExtract.length > 0) {
      if (selectedTrackerCalendarEventExtract.length > 1) {
        setAlertMessage("Please Select single Filing Tracker Record");
        setShowAlert(true);
      } else {
        setShowComments(() => true);
        const selectedEventDeails = await getSelectedEventDetails();
        fetchClientFilingTrackerComments(
          selectedEventDeails[0]?.fileTrackingId,
          selectedEventDeails[0]?.customerId
        );
      }
    } else {
      setAlertMessage("Please Select a Filing Tracker Record");
      setShowAlert(true);
    }
  };

  //History API
  const fetchClientTrackingHistory = async (selectedEventDeailsProps) => {
    try {
      const history = await axios.get(
        `${API_BASE_URL}/Customer/customerfilingtrackingaudit?FileTrackingID=${selectedEventDeailsProps[0].fileTrackingId}`
      );
      setActivityHistory(() => history.data.data);
    } catch (error) {
      console.log("@@Error:", error);
    } finally {
      setIsTnHistoryLoading(false);
    }

    try {
      const history = await axios.get(
        `${API_BASE_URL}/Customer/CustomerFilingMasterAudit${selectedEventDeailsProps[0].customerId}?FilingId=${selectedEventDeailsProps[0].filingId}`
      );
      setClientActivityHistory(() => history.data.data);
    } catch (error) {
      console.log("@@Error:", error);
    } finally {
      setIsCfHistoryLoading(false);
    }

    try {
      const targetCustomerId = (selectedCustomer && selectedCustomer.customerId)
        ? selectedCustomer.customerId
        : (selectedClientId ? parseInt(selectedClientId) : selectedEventDeailsProps[0]?.customerId);

      let payload = [
        {
          customerId: targetCustomerId,
          filingId: selectedEventDeailsProps[0].filingId,
          PreviousStartDate: selectedEventDeailsProps[0].previousStartDate,
        },
      ];
      // console.log("fetchClientTrackingHistory ", "payload", payload);
      const res = await axios.post(
        `${API_BASE_URL}/Customer/CustomerandFilingListBasedOnParentdetails`,
        payload
      );
      const fileTrackingIds = res.data.data
        .map((item) => item.fileTrackingId)
        .join(",");

      const history = await axios.get(
        `${API_BASE_URL}/Customer/customerfilingtrackingcommentaudit?FileTrackingId=${fileTrackingIds}`
      );
      setCommentActivityHistory(() => history.data.data);
    } catch (error) {
      console.log("@@Error:", error);
    } finally {
      setIsCommentsHistoryLoading(false);
    }
  };

  //Display History
  const displayHistory = async () => {
    if (
      selectedTrackerCalendarEventExtract &&
      selectedTrackerCalendarEventExtract[0]?.fileTrackingId
    ) {
      if (
        selectedTrackerCalendarEventExtract &&
        selectedTrackerCalendarEventExtract.length > 1
      ) {
        setAlertMessage("Please Select single Filing Tracker Record");
        setShowAlert(true);
      } else {
        setShowHistory(() => true);
        const selectedEventDeails = await getSelectedEventDetails();
        fetchClientTrackingHistory(selectedEventDeails);
      }
    } else {
      setAlertMessage("Please Select a Filing Tracker Record");
      setShowAlert(true);
    }
  };
  //Reference doccuments api
  const fetchFilingMasterDocuments = async (filingId) => {
    try {
      const attachmentList = await axios.get(
        `${API_BASE_URL}/FilingMaster/FilingMasterAttachments/${filingId}`
      );
      setDocuments(() => attachmentList.data.data);
    } catch (error) {
      console.log("@@Error:", error);
    }
  };

  //Reference Doccuments
  const displayDocuments = async () => {
    if (
      selectedTrackerCalendarEventExtract &&
      selectedTrackerCalendarEventExtract[0]?.customerId
    ) {
      if (selectedTrackerCalendarEventExtract.length > 1) {
        setAlertMessage("Please Select single Filing Tracker Record");
        setShowAlert(true);
      } else {
        fetchFilingMasterDocuments(
          selectedTrackerCalendarEventExtract[0]?.filingId
        );
        setShowDocuments(() => true);
      }
    } else {
      setAlertMessage("Please Select a Filing Tracker Record");
      setShowAlert(true);
    }
  };

  //Consolidated view api
  const fetchConsolidatedRecords = async (selectedFiling) => {
    try {
      const consRecords = await axios.get(
        `${API_BASE_URL}/Customer/CustomerFileTrackingConsolidate?CustomerId=${clientId}&FilingId=${selectedFiling.filingId}&PreviousStartDate=${selectedFiling.previousStartDate}`
      );
      const consStatus = await axios.get(
        `${API_BASE_URL}/Customer/ConsolidateStatusForTracker?CustomerId=${clientId}&FilingId=${selectedFiling.filingId}&PreviousStartDate=${selectedFiling.previousStartDate}`
      );

      setConsolidatedRecords(() => consRecords.data.data);
      setConsolidatedRecordsStatus(() => consStatus.data.data);
    } catch (error) {
      console.log("@@Error:", error);
    }
  };

  //Consolidated view
  const displayConsolidatedView = async () => {
    if (
      selectedTrackerCalendarEventExtract &&
      selectedTrackerCalendarEventExtract[0]?.customerId
    ) {
      if (selectedTrackerCalendarEventExtract.length > 1) {
        setAlertMessage("Please Select single Filing Tracker Record");
        setShowAlert(true);
      } else {
        const selectedEventDeails = await getSelectedEventDetails();

        if (selectedTrackerCalendarEventExtract[0].isUnderParent) {
          // under parent view

          // if (selectedFiling[0].isOnlyParentFile && !selectedFiling[0].isOnlyChildFile) {
          //   //Filing got affected only in parent company not any child
          //   setAlertMessage("There is no affected child company for the selected filing");
          //   setShowAlert(true);
          // } else {

          // Filing got affected only in child company and  both parent and child company
          fetchConsolidatedRecords(selectedEventDeails[0]);
          setShowConsolidated(() => true);

          // }
        } else {
          // under Single company or child view
          setAlertMessage(
            "Under this client, there is no affected child company."
          );
          setShowAlert(true);
        }
      }
    } else {
      setAlertMessage("Please Select a Filing Tracker Record");
      setShowAlert(true);
    }
  };

  //Delete filings
  const {
    AlertDialog: ConfirmDialog,
    showDialog,
    closeDialog,
  } = useDialog({
    onSubmit: () => handleSubmit(),
    onClose: closeConfirm,
  });

  const handleSubmit = () => {
    // deleteCategory();
    if (isDeleteClientFiling) {
      deleteClientFiling();
      setIsDeleteClientFiling(false);
    } else if (selectedTrackerCalendarEventExtract[0].isMasterFiling) {
      deleteRecord();
    } else {
      deleteMasterRecord();
    }
  };

  //Detete functions
  const deleteClientFiling = async () => {
    let payload = [
      {
        FileTrackingID: selectedTrackerCalendarEventExtract[0].fileTrackingId,
        customerId: selectedTrackerCalendarEventExtract[0].customerId,
        filingId: selectedTrackerCalendarEventExtract[0].filingId,
        year:
          new Date(
            selectedTrackerCalendarEventExtract[0].startdate
          ).getFullYear() + "",
        UserId: authUser.userId + "",
      },
    ];
    try {
      const res = await axios.post(
        `${API_BASE_URL}/Customer/CustomerFileTrackerSpecificFilingDelete`,
        payload
      );
      if (res) {
        fetchCalendarEvents(currentCalenderEvents, true);
        setAlertMessage(
          <Typography>
            Successfully deleted:{" "}
            <Typography fontWeight="bold" component="span">
              {selectedTrackerCalendarEventExtract[0].filingName}
            </Typography>{" "}
          </Typography>
        );
        setShowAlert(true);
        setSelectedTrackerCalendarEventDetails([]);
        setSelectedTrackerCalendarEventExtract([]);
        setSelectedTrackerCalendarEvent([]);
        closeDialog();
      }
    } catch (error) {
      setAlertMessage(
        <Typography>
          Unexpected Error occured while deleting :{" "}
          <Typography fontWeight="bold" component="span">
            {selectedTrackerCalendarEventExtract[0].filingName}
          </Typography>{" "}
        </Typography>
      );
      setShowAlert(true);
      closeDialog();
    }
  };
  const deleteRecord = async () => {
    let payload = [
      {
        fileTrackingId: selectedTrackerCalendarEventExtract[0].fileTrackingId,
        customerId: selectedTrackerCalendarEventExtract[0].customerId,
        filingId: selectedTrackerCalendarEventExtract[0].filingId,
        year:
          new Date(
            selectedTrackerCalendarEventExtract[0].startdate
          ).getFullYear() + "",
        UserId: authUser.userId + "",
      },
    ];
    try {
      // console.log("CustomerFilingDelete payload", payload, "selectedFiling", selectedFiling[0]);
      const res = await axios.post(
        `${API_BASE_URL}/Customer/CustomerFilingDelete`,
        payload
      );
      if (res) {
        fetchCalendarEvents(currentCalenderEvents, true);
        setCurrentFilingMaster(null);
        setAlertMessage(
          <Typography>
            Successfully deferred filing :{" "}
            <Typography fontWeight="bold" component="span">
              {selectedTrackerCalendarEventExtract[0].filingName}
            </Typography>{" "}
          </Typography>
        );
        setShowAlert(true);
        closeDialog();
        setSelectedTrackerCalendarEventDetails([]);
        setSelectedTrackerCalendarEventExtract([]);
      }
    } catch (error) {
      setAlertMessage(
        <Typography>
          Unexpected Error occured while deleting filing :{" "}
          <Typography fontWeight="bold" component="span">
            {selectedTrackerCalendarEventExtract[0].filingName}
          </Typography>{" "}
        </Typography>
      );
      setShowAlert(true);
      closeDialog();
    }
  };
  const deleteMasterRecord = async () => {
    if (selectedTrackerCalendarEventExtract) {
      if (
        selectedTrackerCalendarEventExtract[0].status === "Completed" ||
        selectedTrackerCalendarEventExtract[0].status === "Approved"
      ) {
        setAlertMessage(
          <Typography>
            Unable to delete this{" "}
            <Typography fontWeight="bold" component="span">
              {selectedTrackerCalendarEventExtract[0].filingName}
            </Typography>{" "}
            as Status has been Approved or completed.
          </Typography>
        );
        setShowAlert(true);
      } else {
        try {
          let payload = [
            {
              fileTrackingId:
                selectedTrackerCalendarEventExtract[0].fileTrackingId,
              customerId: selectedTrackerCalendarEventExtract[0].customerId,
              filingId: selectedTrackerCalendarEventExtract[0].filingId,
              year:
                new Date(
                  selectedTrackerCalendarEventExtract[0].startdate
                ).getFullYear() + "",
              UserId: authUser.userId + "",
            },
          ];
          // console.log("CustomerFilingDelete payload", payload, "selectedFiling", selectedFiling[0]);
          try {
            const res = await axios.post(
              `${API_BASE_URL}/Customer/CustomerFilingDelete`,
              payload
            );
            if (res) {
              fetchCalendarEvents(currentCalenderEvents, true);
              setCurrentFilingMaster(null);
              setAlertMessage(
                <Typography>
                  This{" "}
                  <Typography fontWeight="bold" component="span">
                    {selectedTrackerCalendarEventExtract[0].filingName}
                  </Typography>{" "}
                  has been successfully deferred.
                </Typography>
              );
              setShowAlert(true);
              closeDialog();
              setSelectedTrackerCalendarEventDetails([]);
              setSelectedTrackerCalendarEventExtract([]);
            }
          } catch (error) {
            setAlertMessage(
              <Typography>
                Unexpected error occured while deleting{" "}
                <Typography fontWeight="bold" component="span">
                  {selectedTrackerCalendarEventExtract[0].filingName}
                </Typography>{" "}
              </Typography>
            );
            setShowAlert(true);
            closeDialog();
          }
        } catch (error) {
          console.log("@@Error:", error);
        }
      }
    } else {
      showAlert("Info", "Please Select a Master Record", "info");
      closeDialog();
    }
  };
  const handleDelete = () => {
    if (selectedTrackerCalendarEventExtract.length === 0) {
      setAlertMessage("Please Select a Client specific Filing");
      setShowAlert(true);
    } else if (selectedTrackerCalendarEventExtract.length === 1) {
      if (!selectedTrackerCalendarEventExtract[0].isMasterFiling) {
        if (selectedClientId) {
          setIsDeleteClientFiling(true);
          showDialog(
            "Confirmation",
            <Typography>
              Are you sure you want to delete this{" "}
              <Typography fontWeight="bold" component="span">
                {selectedTrackerCalendarEventExtract[0].filingName}
              </Typography>{" "}
              record?{" "}
            </Typography>,
            "confirm"
          );
        } else {
          setAlertMessage("Please Select a single Client specific Filing");
          setShowAlert(true);
        }
      } else {
        setAlertMessage("Please Select a Client specific Filing to delete");
        setShowAlert(true);
      }
    } else {
      setAlertMessage("Please Select a single Client specific Filing");
      setShowAlert(true);
    }
  };
  const handleDeleteRecord = async () => {
    // console.log("handleDeleteRecord", "selectedTrackerCalendarEventExtract", selectedTrackerCalendarEventExtract);

    if (
      selectedClientId &&
      selectedTrackerCalendarEventExtract &&
      selectedTrackerCalendarEventExtract.length === 1
    ) {
      const selectedEventDetails = await getSelectedEventDetails();
      // console.log("selectedEventDetails", selectedEventDetails);
      if (
        selectedTrackerCalendarEventExtract[0].isOnlyChildFile &&
        selectedTrackerCalendarEventExtract[0].isUnderParent
      ) {
        setAlertMessage(
          "Only Parent filing is allowed to defer. Please try to defer from Consolidated view"
        );
        setShowAlert(true);
      } else {
        if (
          selectedClientId &&
          selectedEventDetails &&
          (selectedEventDetails[0].status === "Completed" ||
            selectedEventDetails[0].status === "Approved")
        ) {
          setAlertMessage(
            <Typography>
              Unable to defer this{" "}
              <Typography fontWeight="bold" component="span">
                {selectedEventDetails[0].filingName}
              </Typography>{" "}
              as Status has been Approved or completed.
            </Typography>
          );
          setShowAlert(true);
        } else {
          showDialog(
            "Confirmation",
            <Typography>
              Are you sure you want to move this{" "}
              <Typography fontWeight="bold" component="span">
                {selectedEventDetails[0].filingName}
              </Typography>{" "}
              to deferred list?{" "}
            </Typography>,
            "confirm"
          );
        }
      }
    } else {
      if (selectedTrackerCalendarEventExtract.length > 1) {
        setAlertMessage("Please select a single filing ");
        setShowAlert(true);
      } else {
        setAlertMessage("Please select a filing ");
        setShowAlert(true);
      }
    }
  };
  const updateBulkStatus = async () => {
    if (
      selectedTrackerCalendarEventExtract &&
      selectedTrackerCalendarEventExtract[0]?.fileTrackingId
    ) {
      if (
        selectedTrackerCalendarEventExtract &&
        selectedTrackerCalendarEventExtract.length > 1
      ) {
        let payload1 = selectedTrackerCalendarEventExtract.map((ele) => {
          return {
            customerId: ele.customerId,
            filingId: ele.filingId,
            PreviousStartDate: ele.previousStartDate,
            customerType: selectedCustomer.clientType
          };
        });
        const res = await axios.post(
          `${API_BASE_URL}/Customer/CustomerandFilingListBasedOnParentdetailsandCommonstaffs`,
          payload1
        );
        setBulkUpdateRecords(res.data.data.trackingList);
        setCommonStaffs(res.data.data.multipleFilingCommonStaff);
        // fetchClientTrackingHistory(selectedFiling.fileTrackingId);
        // setShowHistory(() => true);
        setShowBulkStatusDrawer(() => true);
      } else {
        setAlertMessage(
          "Please Select more than one Filing Tracker Record for bulk status update"
        );
        setShowAlert(true);
      }
    } else {
      setAlertMessage("Please Select a Filing Tracker Record");
      setShowAlert(true);
    }
  };

  const getSelectedEventDetails = async () => {
    console.log(
      "getSelectedEventDetails selectedTrackerCalendarEventExtract",
      selectedTrackerCalendarEventExtract
    );

    const res = await axios.get(
      `${API_BASE_URL}/CalenderView/Tracker/FilingdetailsBasedonId?FileTrackingID=${selectedTrackerCalendarEventExtract[0].fileTrackingId}&CustomerId=${selectedTrackerCalendarEventExtract[0].customerId}&Year=${currentCalendarYear}`
    );
    setSelectedTrackerCalendarEventDetails(res.data.data);
    return res.data.data;
  };

  const handleChildCompanyChange = (e, affectedCompanyListsDropdown) => {
    console.log("handleChildCompanyChange", "e", e);
    const nextValue = normalizeSelectedIds(e?.target?.value ?? e?.value);
    const selectedCompanyNames = nextValue.map((selectedId) => {
      const selectedCompany = affectedCompanyListsDropdown.find(
        (company) => String(company.customerId) === String(selectedId)
      );
      return selectedCompany
        ? {
          customerId: selectedCompany.customerId,
          customerName: selectedCompany.customerName,
        }
        : []; // Return customerName if found, otherwise an empty string
    });
    setCustomerNames(selectedCompanyNames);
    setSelectedAffectedCompanies(nextValue);
  };
  const handleChildCompanyChangeEdit = (e, action) => {
    console.log("handleChildCompanyChange", "e", e);
    const nextValue = normalizeSelectedIds(e?.target?.value ?? e?.value);
    const selectedCompanyNames = nextValue.map((selectedId) => {
      const selectedCompany = affectedCompanyLists.find(
        (company) => String(company.customerId) === String(selectedId)
      );
      return selectedCompany
        ? {
          customerId: selectedCompany.customerId,
          customerName: selectedCompany.customerName,
        }
        : []; // Return customerName if found, otherwise an empty string
    });


    const filteredValues = nextValue.filter(
      (value) => !selectedAffectedCompaniesEditInitial.includes(value)
    );
    const filteredNames = selectedCompanyNames.filter(
      (value) =>
        !selectedAffectedCompaniesEditInitialNames.some(
          (initialValue) => initialValue.customerId === value.customerId
        )
    );
    const selAffectedCompIds = [
      ...selectedAffectedCompaniesEditInitial,
      ...filteredValues,
    ];
    const selAffectedCompNames = [
      ...selectedAffectedCompaniesEditInitialNames,
      ...filteredNames,
    ];

    setCustomerNames(selAffectedCompNames);
    setSelectedAffectedCompaniesEdit(selAffectedCompIds);
  };
  const fetchAffectedCompanies = async () => {
    try {
      //console.log("fetchAffectedCompanies filingId", selectedFiling);

      const list = await axios.get(
        `${API_BASE_URL}/Customer/CustomerListBasedOnParentId?CustomerId=${selectedClientId}`
      );

      //const filteredList = list.data.data.filter(item => item.parentCustomerId !== 0);

      setAffectedCompanyLists(list.data.data); // Assuming setAffectedCompanyLists is a state setter
      return list.data.data; // Returning the fetched data
    } catch (error) {
      console.log("@@Error:", error);
      throw error; // Re-throwing the error for potential handling elsewhere
    }
  };
  const handleCheckboxChange = (val, e) => {
    e.stopPropagation();
    if (
      !selectedTrackerCalendarEvent ||
      selectedTrackerCalendarEvent.length === 0
    ) {
      // Initially, if no event is selected, add the current event as an array
      // console.log("handleEventChange - Initial Selection", val);
      setSelectedTrackerCalendarEvent([val]);
      // setOpenCalendarDetails(true)
    } else {
      // Check if the clicked event is already selected
      const isAlreadySelected = selectedTrackerCalendarEvent.some(
        (item) =>
          item._def.extendedProps.fileTrackingId ===
          val._def.extendedProps.fileTrackingId
      );

      if (isAlreadySelected) {
        // If already selected, unselect it
        const filteredEvents = selectedTrackerCalendarEvent.filter(
          (item) =>
            item._def.extendedProps.fileTrackingId !==
            val._def.extendedProps.fileTrackingId
        );
        //   console.log("handleEventChange - Unselecting Event", val, filteredEvents);
        setSelectedTrackerCalendarEvent(filteredEvents);
      } else {
        // If not selected, add it to the selected list
        const newlySelectedEvents = [...selectedTrackerCalendarEvent, val];

        //  console.log("handleEventChange - Adding Event", val, newlySelectedEvents);
        setSelectedTrackerCalendarEvent(newlySelectedEvents);
        //setOpenCalendarDetails(true)
      }
    }
  };

  const handleEventChangeDisplay = (val) => {
    try {

      setOpenCalendarDetails(true);
      setSelectedTrackerCalendarEventDisplay(val);
    } catch (error) {
      console.log("handleEventChangeDisplay error", error);

    }
  };
  const fetchCustomerList = async () => {
    //  if (getCustomers) {
    let custList;
    if (customers) {
      custList = customers;
    } else {
      custList = await getCustomers();
    }
    //let custList = await getCustomers();
    let client = custList.filter(
      (ele) => ele.customerId === parseInt(selectedClientId)
    )[0];
    setCurrentFilingMaster({
      ...selectedTrackerCalendarEventDetails[0],
      customerId: selectedClientId,
      client: client.customerName,
      from: "Add client filing",
    });

    // };
  };
  // const addMasterFilling = async () => {
  //   if (selectedClientId) {
  //     // if (getCustomers) {
  //     try {
  //       // let custList = await getCustomers();
  //       // let client = custList.filter(
  //       //   (ele) => ele.customerId === parseInt(selectedClientId)
  //       // )[0];
  //       // setCurrentFilingMaster({
  //       //   customerId: selectedClientId,
  //       //   client: client.customerName,
  //       //   from: "Add client filing",
  //       // });
  //       const list = await fetchAffectedCompanies();
  //       if (
  //         selectedCustomer &&
  //         ((selectedCustomer.parentCustomer !== 0 &&
  //           selectedCustomer.parentCustomer !== null) ||
  //           selectedCustomer?.isOnlyParentFile)
  //       ) {
  //         //if customer is child
  //         if (
  //           selectedCustomer.trackNowLicenseId > 0 &&
  //           selectedCustomer.postAwardLicenseId > 0
  //         ) {
  //           //if child customer has both subscription
  //           setShowRadio1(true);
  //         } else if (
  //           selectedCustomer.trackNowLicenseId > 0 &&
  //           (selectedCustomer.postAwardLicenseId === 0 ||
  //             selectedCustomer.postAwardLicenseId === null)
  //         ) {
  //           //if child customer has only TN subscription
  //           navigate("/filing-master", {
  //             state: {
  //               selectedAffectedCompanies,
  //               customerNames,
  //               isCalenderView: true,
  //               from: "/calendar",
  //               mode: "add",
  //             },
  //           });
  //           fetchCustomerList();
  //           // onAddClientSpecificFilingClick(true);
  //         } else {
  //           //If child customer has PA subscription
  //           navigate("/postaward-master-form", {
  //             state: {
  //               selectedAffectedCompanies,
  //               customerNames,
  //               isCalenderView: true,
  //             },
  //           });
  //           fetchCustomerList();
  //           //onAddClientSpecificFilingClick(true);
  //         }
  //       } else {
  //         //If customer is parent
  //         setShowRadio1(true);
  //       }
  //     } catch (error) { }
  //     //}
  //   } else {
  //     setAlertMessage("Please Select a Client Record");
  //     setShowAlert(true);
  //   }
  // };

  const addMasterFilling = async () => {
    if (isAddClientFilingDisabled) return;
    console.log(
      "addMasterFilling",
      "selectedCustomer",
      selectedCustomer,
      "isTrackNowAccess",
      isTrackNowAccess,
      "isPostAwardAccess",
      isPostAwardAccess,
      "roleType",
      roleType,
      affectedCompanyLists
    );
    if (selectedClientId) {
      // if (getCustomers) {
      try {
        // let custList = await getCustomers();
        // let client = custList.filter(
        //   (ele) => ele.customerId === parseInt(selectedClientId)
        // )[0];
        // setCurrentFilingMaster({
        //   customerId: selectedClientId,
        //   client: client.customerName,
        //   from: "Add client filing",
        // });
        const list = await fetchAffectedCompanies();
        if (
          selectedCustomer.trackNowLicenseId > 0 && selectedCustomer.postAwardLicenseId === 0 &&
          !isTrackNowAccess
        ) {
          setAlertMessage("User doesn't have permission to add Post Award Filing");
          setShowAlert(true)
          return;
        }

        if (
          selectedCustomer.postAwardLicenseId > 0 && selectedCustomer.trackNowLicenseId === 0 &&
          !isPostAwardAccess
        ) {
          setAlertMessage("User doesn't have permission to add TrackNow Filing");
          setShowAlert(true)

          return;
        }
        if (
          selectedCustomer &&
          (selectedCustomer.clientType === "SubChild"
            ||
            selectedCustomer?.isOnlyParentFile || (selectedCustomer?.clientType === "Child" && !selectedCustomer?.bothChildAndSubChild))
        ) {

          //if customer is child
          if (
            selectedCustomer.trackNowLicenseId > 0 &&
            selectedCustomer.postAwardLicenseId > 0
          ) {
            console.log("Check 1");

            if (isTrackNowAccess && isPostAwardAccess) {
              openCreateRecordDialog(list);
            } else if (isPostAwardAccess) {

              navigate("/postaward-master-form", {
                state: {
                  selectedAffectedCompanies,
                  customerNames,
                  isCalenderView: true,
                },
              });
              fetchCustomerList();
              onAddClientSpecificFilingClick(true);
            } else {
              navigate("/filing-master", {
                state: {
                  selectedAffectedCompanies,
                  customerNames,
                  isCalenderView: true,
                  from: "/calendar",
                  mode: "add",
                },
              });
              fetchCustomerList();
              onAddClientSpecificFilingClick(true);
            }
            //if child customer has both subscription
          } else if (
            selectedCustomer.trackNowLicenseId > 0 && isTrackNowAccess &&
            (selectedCustomer.postAwardLicenseId === 0 ||
              selectedCustomer.postAwardLicenseId === null)
          ) {

            //if child customer has only TN subscription
            navigate("/filing-master", {
              state: {
                selectedAffectedCompanies,
                customerNames,
                isCalenderView: true,
                from: "/calendar",
                mode: "add",
              },
            });
            fetchCustomerList();
            onAddClientSpecificFilingClick(true);
          } else {
            //If child customer has PA subscription
            navigate("/postaward-master-form", {
              state: {
                selectedAffectedCompanies,
                customerNames,
                isCalenderView: true,
              },
            });
            fetchCustomerList();
            onAddClientSpecificFilingClick(true);
          }
        } else {
          //If customer is parent
          openCreateRecordDialog(list);
        }
      } catch (error) {
        //log("error", error);
      } finally {
        //setClearSelectedRecords(true)
        setSelectedTrackerCalendarEvent([])
        setSelectedTrackerCalendarEventExtract([])
      }
      //}
    } else {
      setAlertMessage("Please Select a Client Record");
      setShowAlert(true);
    }
  };
  const editMasterFilling = async () => {
    // console.log(
    //   "editMasterFilling",
    //   "selectedCustomer",
    //   selectedCustomer,
    //   "isTrackNowAccess", isTrackNowAccess, "isPostAwardAccess", isPostAwardAccess, "roleType", roleType
    // );

    if (selectedClientId &&
      selectedTrackerCalendarEvent &&
      selectedTrackerCalendarEvent.length !== 0) {

      if (selectedClientId &&
        selectedTrackerCalendarEvent &&
        selectedTrackerCalendarEvent.length > 1) {
        setAlertMessage("Please Select single Client specific Filing ");
        setShowAlert(true);
      } else {
        let selectedEventDeails = await getSelectedEventDetails();
        console.log("selectedEventDeails", selectedEventDeails);
        if (!selectedEventDeails[0].isMasterFiling) {
          console.log("editMasterFilling", "consRecords", selectedEventDeails[0]);
          if (
            selectedEventDeails[0].recordType === "TrackNow" &&
            !isTrackNowAccess
          ) {

            setAlertMessage("User doesn't have permission to edit Tracknow Filing");
            setShowAlert(true)
            return;
          }

          if (
            selectedEventDeails[0].recordType === "PostAward" &&
            !isPostAwardAccess
          ) {

            setAlertMessage("User doesn't have permission to edit PostAward Filing");
            setShowAlert(true)

            return;
          }
          const list = await fetchAffectedCompanies();
          if (
            ((selectedCustomer?.clientType === "Parent" && !selectedCustomer.isOnlyParentFile) || (selectedCustomer?.clientType === "Child" && selectedCustomer?.bothChildAndSubChild))

          ) {
            const listConst = await axios.get(
              `${API_BASE_URL}/Customer/CustomerFileTrackingConsolidate?CustomerId=${clientId}&FilingId=${selectedEventDeails[0].filingId}&PreviousStartDate=${selectedEventDeails[0].previousStartDate}`
            );

            const constRecords = listConst.data.data;
            const exsistingChildCompany = list.map((item) => {
              const matchingRecords = constRecords.find(
                (cust) => cust.customerId === item.customerId
              );
              console.log(",matchingRecords", matchingRecords, "item", item);
              if (matchingRecords) {
                selectedAffectedCompanies.push(matchingRecords.customerId);
                selectedAffectedCompaniesEdit.push(matchingRecords.customerId);
                selectedAffectedCompaniesEditInitial.push(
                  matchingRecords.customerId
                ); //prev customerId
                customerNames.push({
                  customerId: matchingRecords.customerId,
                  customerName: matchingRecords.customerName,
                }); //prev customername
                selectedAffectedCompaniesEditInitialNames.push({
                  customerId: matchingRecords.customerId,
                  customerName: matchingRecords.customerName,
                }); //prev customername
              }
              return {
                ...item,
                isDisabled: matchingRecords ? true : false,
              };
            });
            constRecords.forEach((record) => {
              if (record.customerId === selectedCustomer.customerId) {
                if (
                  !customerNames.some(
                    (cust) => cust.customerName === record.customerName
                  )
                ) {
                  console.log(
                    "record ",
                    record,
                    "customerNames",
                    customerNames,
                    "constRecords",
                    constRecords
                  );
                  customerNames.push({
                    customerId: record.customerId,
                    customerName: record.customerName,
                  });
                }
              }
            });

            setAffectedCompanyLists(exsistingChildCompany);
            setShowRadioEdit(true);
            // editFiling()
          } else {
            editFiling();
          }
        } else {
          setAlertMessage("Please Select a Client specific Filing to edit ");
          setShowAlert(true);
        }
      }
      //}
    } else {
      setAlertMessage("Please Select a Client specific Filing ");
      setShowAlert(true);
    }
  }


  const editFiling = async () => {
    try {
      if (
        selectedClientId &&
        selectedTrackerCalendarEvent &&
        selectedTrackerCalendarEvent.length !== 0
      ) {
        if (
          selectedClientId &&
          selectedTrackerCalendarEvent &&
          selectedTrackerCalendarEvent.length > 1
        ) {
          setAlertMessage("Please Select single Client specific Filing ");
          setShowAlert(true);
        } else {
          let selectedEventDeails = await getSelectedEventDetails();
          if (!selectedEventDeails[0].isMasterFiling) {
            // if (getCustomers) {
            try {
              let custList;
              if (customers) {
                custList = customers;
              } else {
                custList = await getCustomers();
              }
              //  let custList = await getCustomers();
              let client = custList.filter(
                (ele) => ele.customerId === parseInt(selectedClientId)
              )[0];
              setCurrentFilingMaster({
                ...selectedEventDeails[0],
                juristiction: selectedEventDeails[0]?.filingJuristiction,
                stateInfo: selectedEventDeails[0]?.filingStateInfo,
                customerId: selectedClientId,
                client: client.customerName,
                from: "Edit client filing",
              });

              if (selectedEventDeails[0]?.recordType === "TrackNow") {
                onAddClientSpecificFilingClick(true);

                navigate("/filing-master", {
                  state: {
                    selectedAffectedCompanies,
                    selectedAffectedCompaniesEdit,
                    customerNames,
                    isCalenderView: true,
                    from: "/calendar",
                    mode: "edit",
                  },
                });
              } else {
                onAddClientSpecificFilingClick(true);

                navigate("/postaward-master-form", {
                  state: {
                    selectedAffectedCompanies,
                    selectedAffectedCompaniesEdit,
                    customerNames,
                    isCalenderView: true,
                  },
                });
              }
            } catch (error) { }
          } else {
            setAlertMessage("Please Select a Client specific Filing to edit ");
            setShowAlert(true);
          }
        }
        //}
      } else {
        setAlertMessage("Please Select a Client specific Filing ");
        setShowAlert(true);
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      setSelectedTrackerCalendarEvent([])
      setSelectedTrackerCalendarEventExtract([])
      setSelectedAffectedCompanies([]);
      setSelectedAffectedCompaniesEdit([]);
      setCustomerNames([]);
      setSelectedAffectedCompaniesEditInitial([]);
      setSelectedAffectedCompaniesEditInitialNames([]);
    }
  };

  const radioOkButton1 = () => {
    try {
      if (roleType.length > 1) {
        //incase user has two roles
        if (isTrackNowAccess && isPostAwardAccess) {
          //if user has both TN and PA access
          if (radioVal1 === "tracknow") {
            navigate("/filing-master", {
              state: {
                selectedAffectedCompanies,
                customerNames,
                isCalenderView: true,
                from: "/calendar",
                mode: "add",
              },
            });
            fetchCustomerList();
            onAddClientSpecificFilingClick(true);
          } else {
            navigate("/postaward-master-form", {
              state: {
                selectedAffectedCompanies,
                customerNames,
                isCalenderView: true,
              },
            });
            fetchCustomerList();
            onAddClientSpecificFilingClick(true);
          }
        } else if (isTrackNowAccess) {
          //TN roles
          navigate("/filing-master", {
            state: {
              selectedAffectedCompanies,
              customerNames,
              isCalenderView: true,
              from: "/calendar",
              mode: "add",
            },
          });
          fetchCustomerList();
          onAddClientSpecificFilingClick(true);
        } else {
          //PA roles
          navigate("/postaward-master-form", {
            state: {
              selectedAffectedCompanies,
              customerNames,
              isCalenderView: true,
            },
          });
          fetchCustomerList();
          onAddClientSpecificFilingClick(true);
        }
      } else if (isTrackNowAccess) {
        //TN roles
        navigate("/filing-master", {
          state: {
            selectedAffectedCompanies,
            customerNames,
            isCalenderView: true,
            from: "/calendar",
            mode: "add",
          },
        });
        fetchCustomerList();
        onAddClientSpecificFilingClick(true);
      } else if (isPostAwardAccess) {
        //PA roles
        navigate("/postaward-master-form", {
          state: {
            selectedAffectedCompanies,
            customerNames,
            isCalenderView: true,
          },
        });
        fetchCustomerList();
        onAddClientSpecificFilingClick(true);
      }
    } catch (error) {
      console.error("radioOkButton1", error);
    } finally {
      setSelectedAffectedCompanies([]);
      setSelectedAffectedCompaniesEdit([]);
      setCustomerNames([]);
      setSelectedAffectedCompaniesEditInitial([]);
      setSelectedAffectedCompaniesEditInitialNames([]);
    }
  };
  const radioOkButtonEdit = () => {
    editFiling();
  };
  const handleRadioChange1 = (event) => {
    const nextRecordType = event.target.value;
    setSelectedAffectedCompanies([]);
    setSelectedAffectedCompaniesEdit([]);
    setCustomerNames([]);
    setRadioVal1(nextRecordType);
    setAffectedCompanyListsDropdown(
      getAffectedCompaniesByRecordType(affectedCompanyLists, nextRecordType)
    );
  };

  const handleClickOpenForm = () => {
    if (isAddClientFilingDisabled) return;
    addMasterFilling();
  };
  const handleDateChange = (year) => {

    setCurrentCalendarYear(year)
  };

  useEffect(() => {
    if (selectedClientId) {
      fetchCalendarEvents();
    }
  }, [selectedClientId]);

  useEffect(() => {
    if (clientId && selectedCustomer) {
      setSelectedClientId(clientId);
      getStaffList();
    }
  }, [clientId]);
  useEffect(() => {
    if (!selectedCustomer) {
      navigate("/client-filing-tracker-list");
    }
  }, [selectedCustomer]);

  useEffect(() => {
    if (selectedTrackerCalendarEvent?.length > 0) {
      const extEvent = selectedTrackerCalendarEvent.map(
        (item) => item._def.extendedProps
      );
      const updList = extEvent.map((item) => {
        const dueDateFilingFormatted = toLocalTime(item.filingDueDate);
        return {
          ...item,
          dueDateFilingFormatted,
        };
      });

      setSelectedTrackerCalendarEventExtract(updList);
    } else {
      setSelectedTrackerCalendarEventExtract([]);
    }
  }, [selectedTrackerCalendarEvent]);
  useEffect(() => {
    if (clientId) setSelectedClientId(clientId);
    //eslint-disable-next-line
    const hasTrackNowAccess = Boolean(
      roleType?.includes("ClientAdmin") ||
      roleType?.includes("Admin") ||
      roleType?.includes("JSIPOC") ||
      roleType?.includes("HierarchyAdmin")
    );
    const hasPostAwaradAccess = Boolean(
      roleType?.includes("ClientAdmin-PostAward") ||
      roleType?.includes("Admin-PostAward") ||
      roleType?.includes("JSIPOC-PostAward") ||
      roleType?.includes("HierarchyAdmin-PostAward")
    );
    setIsTrackNowAccess(hasTrackNowAccess);
    setIsPostAwardAccess(hasPostAwaradAccess);
  }, [clientId]);

  useEffect(() => {
    try {

      if (radioVal1 === "tracknow") {
        console.log(
          "radioVal1",
          radioVal1,
          "affectedCompanies",
          affectedCompanyLists
        );
        const filtAffectedComp = getAffectedCompaniesByRecordType(
          affectedCompanyLists,
          radioVal1
        );
        setAffectedCompanyListsDropdown(filtAffectedComp);
      } else {
        const filtAffectedComp = getAffectedCompaniesByRecordType(
          affectedCompanyLists,
          radioVal1
        );
        setAffectedCompanyListsDropdown(filtAffectedComp);
      }
    }
    catch (error) {
      //  console.log("error", error);

    }
  }, [radioVal1, affectedCompanyLists]);
  const footerContent = (
    <div>
      <TrackNowButton variant="primary" onClick={() => closeAlert()}>
        OK
      </TrackNowButton>
    </div>
  );
  const radioFooterContent1 = (
    <div style={{ display: "flex", justifyContent: "center", gap: "12px" }}>
      <TrackNowButton variant="tertiary" onClick={() => radioCloseAlert1()}>
        Cancel
      </TrackNowButton>
      <TrackNowButton
        variant="primary"
        onClick={() => radioOkButton1()}
        disabled={
          ((!selectedCustomer?.parentCustomer ||
            selectedCustomer?.parentCustomer === null) &&
            !selectedCustomer?.isOnlyParentFile &&
            selectedAffectedCompanies.length === 0) ||
          (selectedCustomer?.clientType === "Child" &&
            selectedCustomer?.bothChildAndSubChild &&
            selectedAffectedCompanies?.length === 0)
        }
      >
        Submit
      </TrackNowButton>
    </div>
  );
  const radioFooterContentEdit = (
    <div style={{ display: "flex", justifyContent: "center", gap: "12px" }}>
      <TrackNowButton variant="tertiary" onClick={() => radioCloseAlertEdit()}>
        Cancel
      </TrackNowButton>
      <TrackNowButton variant="primary" onClick={() => radioOkButtonEdit()}>
        Submit
      </TrackNowButton>
    </div>
  );

  const renderHeaderLegend = () => {
    return (
      <div style={{ display: "flex", flexDirection: "column", }}>
        <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <div style={{ width: "12px", height: "12px", backgroundColor: "#28a745", borderRadius: "2px" }}></div>
          <span>Completed</span>
        </span>
        <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <div style={{ width: "12px", height: "12px", backgroundColor: "#dc3545", borderRadius: "2px" }}></div>
          <span>Past Due</span>
        </span>
        <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <div style={{ width: "12px", height: "12px", backgroundColor: "#4f46e5", borderRadius: "2px" }}></div>
          <span>Upcoming</span>
        </span>
      </div>
    );
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Check on initial render

    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const normalizeSelectedIds = (value) => {
    if (Array.isArray(value)) return value;
    if (typeof value === "string") return value.split(",").filter(Boolean);
    return [];
  };
  const getCompanyNameById = (list, id) => {
    const match = list.find((company) => String(company.customerId) === String(id));
    return match?.customerName || String(id);
  };
  const getCompanySelectionSummary = (selected, list) => {
    const ids = normalizeSelectedIds(selected);
    if (ids.length === 0) return "Select Company";
    const firstName = getCompanyNameById(list, ids[0]);
    const extraCount = ids.length - 1;
    if (extraCount <= 0) return firstName;
    const suffix = ` + ${extraCount} more`;
    const maxSummaryLength = 26;
    const reservedForEllipsis = 3;
    const maxFirstPart = Math.max(
      8,
      maxSummaryLength - suffix.length - reservedForEllipsis
    );
    const compactFirstName =
      firstName.length > maxFirstPart
        ? `${firstName.slice(0, maxFirstPart).trimEnd()}...`
        : firstName;
    return `${compactFirstName}${suffix}`;
  };
  const renderCompanySelectedItem = (value, selectedValues) => {
    const ids = normalizeSelectedIds(selectedValues).map((id) => String(id));
    if (ids.length === 0) return "Select Company";
    if (String(value) !== ids[0]) return null;
    return getCompanySelectionSummary(ids, affectedCompanyListsDropdown);
  };
  const companySelectOptions = affectedCompanyListsDropdown.map((company) => ({
    label: company.customerName,
    value: String(company.customerId),
    disabled: Boolean(company.isDisabled),
  }));
  const renderCompanyPanelHeader = (options) => (
    <div className={options.className}>
      <div className="company-dialog-multiselect-header">
        <div className="company-dialog-multiselect-header-left">
          {options.checkboxElement}
          <span>Select All</span>
        </div>
      </div>
    </div>
  );
  console.log("searchConfig", "searchBy", searchConfig.searchBy, "searchType", searchConfig.searchType, "searchVal", searchConfig.searchVal);

  return (
    <Fragment>
      <div style={{ display: "flex", alignItems: "flex-start", width: "100%" }}>
        <Grid sx={{ height: "100%", width: "93%" }}>
          <div
            className="card"
            style={{
              maxWidth: "90vw",
              padding: "1rem",
              margin: "1rem",
              background: "#FFF",
              borderRadius: "2%",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "20px",
                left: "200px",
                zIndex: 999,
              }}

            >
              <IconButton
                aria-describedby="filter-menu"
                onClick={(e) => setAnchorEl(e.currentTarget)}
                style={{ width: "10px", height: "10px", borderRadius: "50%" }}
                sx={{ color: primaryColor }}
              >
                {isSearch ? <FilterAltOffIcon sx={{ color: primaryColor }} /> : <FilterAltIcon sx={{ color: primaryColor }} />}
              </IconButton>

              <Popover
                id="filter-menu"
                open={openFilter}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                PaperProps={{
                  sx: {
                    backgroundColor: tokens.colors.offWhite,
                    border: '1px solid #ccc'
                  }
                }}
              >
                <Box sx={{ p: 2, width: 350, maxHeight: 500, overflowY: 'auto' }}>

                  {/* <FormControl
                    fullWidth
                    size="small"
                  >
                    <InputLabel id="search-criterion-label">Filter By</InputLabel>
                    <Select
                      labelId="search-criterion-label"
                      value={searchConfig.searchBy}
                      onChange={(e) =>
                        setSearchConfig({
                          searchBy: e.target.value,
                          searchType: "",
                          searchVal: "",
                        })
                      }
                      label="Filter By"

                    >
                      <MenuItem sx={{ padding: "1px 16px" }} value="FilingName">Filing Name</MenuItem>
                      <MenuItem sx={{ padding: "1px 16px" }} value="Status">Status</MenuItem>
                      <StyledDivider />
                      <ListSubheader
                        sx={{
                          fontWeight: 900,
                          fontSize: "medium",
                          paddingLeft: "14px",
                          lineHeight: "25px"
                        }}
                      >
                        Jurisdiction
                      </ListSubheader>
                      <MenuItem sx={{ padding: "1px 16px", marginLeft: "10px" }} value="StateInfo">State</MenuItem>
                      <MenuItem sx={{ padding: "1px 16px", marginLeft: "10px" }} value="Federal">Federal</MenuItem>
                      <MenuItem sx={{ padding: "1px 16px", marginLeft: "10px" }} value="Both">Both</MenuItem>
                      <StyledDivider />
                      <MenuItem sx={{ padding: "1px 16px" }} value="StaffAssigned">Staff Assigned</MenuItem>
                      {selectedCustomer?.parentCustomer === null ||
                        !selectedCustomer?.isOnlyParentFile ? (
                        <MenuItem sx={{ padding: "1px 16px" }} value="CustomerName">Affected Company</MenuItem>
                      ) : null}
                    </Select>
                  </FormControl> */}

                  <TextField
                    select
                    fullWidth
                    label="Column"
                    size="small"
                    value={searchConfig.searchBy}
                    onChange={(e) =>
                      setSearchConfig({
                        searchBy: e.target.value,
                        searchType: e.target.value === "Juristiction" ? "Contains" : "",
                        searchVal: "",
                      })
                    }
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: tokens.colors.offWhite,
                        '& fieldset': {
                          borderColor: '#ccc',
                        },
                        '&:hover fieldset': {
                          borderColor: primaryColor
                        },
                      },
                    }}
                  >
                    <MenuItem value="FilingName">Filing Name</MenuItem>
                    <MenuItem value="Status">Status</MenuItem>
                    <MenuItem value="StateInfo">State</MenuItem>
                    <MenuItem value="Juristiction">Jurisdiction</MenuItem>
                    {/* <MenuItem value="StaffAssigned">Staff Assigned</MenuItem> */}
                    {selectedCustomer?.parentCustomer !== null ? (
                      <MenuItem value="StaffAssigned">Staff Assigned</MenuItem>
                    ) : null}
                    {selectedCustomer?.parentCustomer === null ||
                      !selectedCustomer?.isOnlyParentFile ? (
                      <MenuItem value="CustomerName">Affected Company</MenuItem>
                    ) : null}

                  </TextField>

                  {/* <FormControl
                    size="small"
                    fullWidth
                  >
                    <InputLabel id="search-type-label">Filter Type</InputLabel>
                    <Select
                      labelId="search-type-label"
                      value={searchConfig.searchType}
                      onChange={(e) =>
                        setSearchConfig({
                          ...searchConfig,
                          searchType: e.target.value,
                        })
                      }
                      label="Filter Type"
                    >
                      <MenuItem value="Contains">Contains</MenuItem>
                      <MenuItem value="NotContains">Not Contains</MenuItem>
                      <MenuItem value="EqualTo">Equal</MenuItem>
                    </Select>
                  </FormControl> */}
                  {searchConfig.searchBy && searchConfig.searchBy !== "Juristiction" && (
                    <TextField
                      select
                      fullWidth
                      label="Condition"
                      size="small"
                      sx={{
                        mt: 2,
                        '& .MuiOutlinedInput-root': {
                          backgroundColor: tokens.colors.offWhite,
                          '& fieldset': {
                            borderColor: '#ccc',
                          },
                          '&:hover fieldset': {
                            borderColor: primaryColor
                          },
                        },
                      }}
                      value={searchConfig.searchType}
                      onChange={(e) =>
                        setSearchConfig({
                          ...searchConfig,
                          searchType: e.target.value,
                        })
                      }
                    >
                      <MenuItem value="Contains">Contains</MenuItem>
                      <MenuItem value="NotContains">Is Not</MenuItem>
                      {searchConfig.searchBy !== "StateInfo" && (
                        <MenuItem value="EqualTo">Is</MenuItem>
                      )}
                    </TextField>
                  )}
                  {searchConfig.searchType && searchConfig.searchBy && (
                    <Box sx={{}}>
                      <Typography variant="body2" sx={{ mb: 1 }}>
                        {searchConfig.searchBy === "Status"
                          ? "Select Status:"
                          : searchConfig.searchBy === "StateInfo"
                            ? "Select State:"
                            : searchConfig.searchBy === "Juristiction"
                              ? "Select Value:"
                              : ""}
                      </Typography>

                      {/* STATUS RADIO */}
                      {searchConfig.searchBy === "Status" && (
                        <Box
                          sx={{
                            maxHeight: 200,
                            overflowY: "auto",
                            border: "1px solid #ccc",
                            borderRadius: "10px",
                            p: 1,
                            backgroundColor: tokens.colors.offWhite,
                          }}
                        >
                          <RadioGroup
                            value={searchConfig.searchVal || ""}
                            onChange={(e) =>
                              setSearchConfig({
                                ...searchConfig,
                                searchVal: e.target.value,
                              })
                            }
                          >
                            {[
                              { label: "In Progress", value: "Inprogress" },
                              { label: "Completed", value: "Completed" },
                              { label: "Pending", value: "Pending" },
                              { label: "Approved", value: "Approved" },
                            ].map((item) => (
                              <FormControlLabel
                                key={item.value}
                                value={item.value}
                                control={<Radio size="small" />}
                                label={item.label}
                                sx={{
                                  '& .MuiFormControlLabel-label': {
                                    fontSize: "14px",
                                  },
                                  mb: 0.5,
                                }}
                              />
                            ))}
                          </RadioGroup>
                        </Box>
                      )}

                      {/* STATE RADIO */}
                      {searchConfig.searchBy === "StateInfo" && (
                        <Box
                          sx={{
                            maxHeight: 200,
                            overflowY: "auto",
                            border: "1px solid #ccc",
                            borderRadius: "10px",
                            p: 1,
                            backgroundColor: tokens.colors.offWhite,
                          }}
                        >
                          <RadioGroup
                            value={searchConfig.searchVal || ""}
                            onChange={(e) =>
                              setSearchConfig({
                                ...searchConfig,
                                searchVal: e.target.value,
                              })
                            }
                          >
                            {states.map((ele) => (
                              <FormControlLabel
                                key={ele.code}
                                value={ele.code}
                                control={<Radio size="small" />}
                                label={ele.state}
                                sx={{
                                  '& .MuiFormControlLabel-label': {
                                    fontSize: "14px",
                                  },
                                  mb: 0.5,
                                }}
                              />
                            ))}
                          </RadioGroup>
                        </Box>
                      )}

                      {/* TEXT INPUT (unchanged logic) */}
                      {searchConfig.searchBy !== "Status" &&
                        searchConfig.searchBy !== "StateInfo" &&
                        searchConfig.searchBy !== "Juristiction" && (
                          <TextField
                            fullWidth
                            label="Value"
                            size="small"
                            sx={{
                              mt: 1,
                              '& .MuiOutlinedInput-root': {
                                backgroundColor: tokens.colors.offWhite,
                                borderRadius: "10px",
                                '& fieldset': {
                                  borderColor: '#ccc',
                                },
                                '&:hover fieldset': {
                                  borderColor: primaryColor
                                },
                              },
                            }}
                            value={searchConfig.searchVal}
                            disabled={
                              searchConfig.searchBy === "Federal" ||
                              searchConfig.searchBy === "Both"
                            }
                            onChange={(e) =>
                              setSearchConfig({
                                ...searchConfig,
                                searchVal: e.target.value,
                              })
                            }
                          />
                        )}
                      {/* { juristiction} */}
                      {searchConfig.searchBy === "Juristiction" && (
                        <Box
                          sx={{
                            maxHeight: 200,
                            overflowY: "auto",
                            border: "1px solid #ccc",
                            borderRadius: "10px",
                            p: 1,
                            backgroundColor: tokens.colors.offWhite,
                          }}
                        >
                          <RadioGroup
                            value={searchConfig.searchVal || ""}
                            onChange={(e) =>
                              setSearchConfig({
                                ...searchConfig,
                                searchVal: e.target.value,
                              })
                            }
                          >
                            {["Federal", "State", "Both"].map((val) => (
                              <FormControlLabel
                                key={val}
                                value={val}
                                control={<Radio size="small" />}
                                label={val}
                              />
                            ))}
                          </RadioGroup>
                        </Box>
                      )}
                    </Box>
                  )}
                  <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>

                    <TrackNowButton
                      size="small" variant="secondary"
                      onClick={handleCancelSearch}
                    >
                      Clear
                    </TrackNowButton>
                    <TrackNowButton
                      size="small" variant="primary"
                      disabled={
                        !(
                          searchConfig.searchBy !== "" &&
                          searchConfig.searchType !== "" &&
                          (searchConfig.searchVal !== "" || (searchConfig.searchVal === "" && ["Federal", "Both"].includes(searchConfig.searchBy)))
                        )
                      }
                      onClick={() => handleSearch()}
                    >
                      Apply Filter
                    </TrackNowButton>
                  </Box>
                </Box>
              </Popover>

            </div>
            <div style={{
              position: isSticky ? 'absolute' : 'sticky',
              top: "2px",
              paddingLeft: "55%"
            }}>
              {renderHeaderLegend()}
            </div>
            <Calendar
              calendarEventList={calendarEventList}
              selectedEvent={selectedTrackerCalendarEvent}
              selectedEventDisplay={selectedTrackerCalendarEventDisplay}
              setSelectedEvent={(val, e) => handleCheckboxChange(val, e)}
              setSelectedEventDisplay={(val) => handleEventChangeDisplay(val)}
              onDateSetsChange={fetchCalendarEvents}
              handleAddClient={handleClickOpenForm}
              isAddClientFilingDisabled={isAddClientFilingDisabled}
              onYearChange={(year) => {
                handleDateChange(year)
              }}
              dragAndDropEvent={(val, oldVal) =>
                handleDragAndDropEvent(val, oldVal)
              }
            />
          </div>
        </Grid>
        <Grid
          sx={{
            height: "100%",
            width: "5%",
            position: "sticky",
            top: 10,
            alignSelf: "flex-start",
          }}
        >
          <div
            style={{
              height: "100%",
              background: "transparent",
              marginTop: "0",
            }}
          >
            <Item
              sx={{
                height: "100%",
                background: "transparent",
                boxShadow: "none",
                borderRadius: "50px",
                overflow: "visible"
              }}
            >
              <Toolbox
                displayComments={addComment}
                displayAttachments={displayAttachments}
                displayHistory={displayHistory}
                displayDocuments={displayDocuments}
                displayConsolidatedView={displayConsolidatedView}
                deleteClientFiling={handleDelete}
                deleteRecord={handleDeleteRecord}
                updateBulkStatus={updateBulkStatus}
                editMasterFilling={editMasterFilling}
                printCalendar={generatePdf}
              />
            </Item>
          </div>
        </Grid>
      </div>
      {<ConfirmDragDropDialog />}
      {
        <CustomDialog
          header="Info"
          visible={showAlert}
          onHide={() => closeAlert()}
          footer={null}
        >
          {alertMessage}
        </CustomDialog>
      }
      {
        <CustomDialog
          header={<span style={{ color: tokens.colors.success }}>Confirmation</span>}
          visible={showRadio1}
          onHide={() => radioCloseAlert1()}
          footer={radioFooterContent1}
          icon={<NoticeIllustration />}
          compact
          autoZIndex={false}
          baseZIndex={2400}
          style={{ width: "560px", maxWidth: "90vw" }}
          contentStyle={{ overflow: "visible" }}
        >
          <p className="m-0">{isTrackNowAccess && isPostAwardAccess ? radioMessage1 : ""}</p>
          <FormControl>
            <Stack direction="column" spacing={2}>
              {isTrackNowAccess && isPostAwardAccess && (
                <div className="company-dialog-recordtype-options">
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="radio-buttons-group"
                    value={radioVal1}
                    onChange={handleRadioChange1}
                  >
                    <FormControlLabel
                      disabled={
                        !(selectedCustomer?.trackNowLicenseId && selectedCustomer.trackNowLicenseId > 0) ||
                        !(selectedCustomer?.postAwardLicenseId && selectedCustomer.postAwardLicenseId > 0)
                      }
                      value="tracknow"
                      control={<Radio />}
                      label="Track Now"
                    />
                    <FormControlLabel
                      disabled={
                        !(selectedCustomer?.postAwardLicenseId && selectedCustomer.postAwardLicenseId > 0) ||
                        !(selectedCustomer?.trackNowLicenseId && selectedCustomer.trackNowLicenseId > 0)
                      }
                      value="postaward"
                      control={<Radio />}
                      label="Post Award"
                    />
                  </RadioGroup>
                </div>
              )}
              {((selectedCustomer?.clientType === "Parent" && !selectedCustomer?.isOnlyChildFile) || (selectedCustomer?.clientType === "Child" && selectedCustomer?.bothChildAndSubChild)) &&
                (
                  <div>
                    <FormLabel className={`company-dialog-company-label ${isCompanySelectOpen ? "company-dialog-company-label--active" : ""}`}>
                      <Typography>
                        Please Select Parent/Child/Sub Child Company (s)
                      </Typography>
                    </FormLabel>

                    <MultiSelect
                      value={normalizeSelectedIds(selectedAffectedCompanies).map((id) => String(id))}
                      options={companySelectOptions}
                      onChange={(e) =>
                        handleChildCompanyChange({ value: e.value }, affectedCompanyListsDropdown)
                      }
                      optionLabel="label"
                      optionValue="value"
                      optionDisabled="disabled"
                      placeholder="Select Company"
                      // selectedItemTemplate={(value) => renderCompanySelectedItem(value, selectedAffectedCompanies)}
                      panelHeaderTemplate={renderCompanyPanelHeader}
                      appendTo="self"
                      autoZIndex={false}
                      baseZIndex={2450}
                      className="company-dialog-multiselect"
                      panelClassName="company-dialog-multiselect-panel"
                      onShow={() => setIsCompanySelectOpen(true)}
                      onHide={() => setIsCompanySelectOpen(false)}
                      style={{ width: "100%" }}
                    />
                  </div>
                )}
            </Stack>
          </FormControl>
        </CustomDialog>
      }
      {
        <CustomDialog
          header={<span style={{ color: tokens.colors.success }}>Confirmation</span>}
          visible={showRadioEdit}
          onHide={() => radioCloseAlertEdit()}
          footer={radioFooterContentEdit}
          icon={<NoticeIllustration />}
          compact
          autoZIndex={false}
          baseZIndex={2400}
          contentStyle={{ overflow: "visible" }}
        >
          {/* <p className='m-0'>{radioMessage1}</p> */}
          {(selectedCustomer?.clientType === "Parent" ||
            selectedCustomer?.clientType === "Child") && (
              <FormControl>
                <Stack direction="column" spacing={2}>
                  <FormLabel className={`company-dialog-company-label ${isCompanySelectEditOpen ? "company-dialog-company-label--active" : ""}`}>
                    <Typography>
                      {selectedCustomer?.clientType === "Parent" ? (
                        <span>
                          If you want to add the filing to the Child company as well,
                          please select child Company(s)
                        </span>
                      ) :
                        <span>
                          If you want to add the filing to the Sub Child company as well,
                          please select sub child Company(s)
                        </span>
                      }
                    </Typography>
                  </FormLabel>

                  <MultiSelect
                    value={normalizeSelectedIds(selectedAffectedCompaniesEdit).map((id) => String(id))}
                    options={companySelectOptions}
                    onChange={(e) => handleChildCompanyChangeEdit({ value: e.value }, "edit")}
                    optionLabel="label"
                    optionValue="value"
                    optionDisabled="disabled"
                    placeholder="Select Company"
                    // selectedItemTemplate={(value) => renderCompanySelectedItem(value, selectedAffectedCompaniesEdit)}
                    panelHeaderTemplate={renderCompanyPanelHeader}
                    appendTo="self"
                    autoZIndex={false}
                    baseZIndex={2450}
                    className="company-dialog-multiselect"
                    panelClassName="company-dialog-multiselect-panel"
                    onShow={() => setIsCompanySelectEditOpen(true)}
                    onHide={() => setIsCompanySelectEditOpen(false)}
                    style={{ width: "100%" }}
                  />
                </Stack>
              </FormControl>
            )}
        </CustomDialog>
      }
      <ConfirmDialog />
      {
        <ClientFilingTrackerComments
          show={showComments}
          dockAt="right"
          tracker={selectedTrackerCalendarEventDetails[0]}
          comments={comments}
          handleClose={closeComments}
        // resetRefreshList={resetRefreshList}
        // handleRefreshTable={handleRefreshTable}
        />
      }
      {
        <ClientFilingTrackerAttachment
          show={showAttachments}
          dockAt="right"
          tracker={selectedTrackerCalendarEventDetails[0]}
          attachments={attachments}
          handleClose={closeAttachments}
        // refreshAttachments={refreshAttachments}
        // handleRefreshTable={handleRefreshTable}
        />
      }
      {
        <ClientFilingTrackerHistory
          show={showHistory}
          dockAt="right"
          tracker={selectedTrackerCalendarEventExtract[0]}
          activityHistory={activityHistory}
          isCommentsTabLoading={isCommentsHistoryLoading}
          isTrackNowTabLoading={isTnistoryLoading}
          isClientFilingTabLoading={isCfHistoryLoading}
          clientActivityHistory={clientActivityHistory}
          commentActivityHistory={commentActivityHistory}
          handleClose={closeHistory}
          setActivityHistory={setActivityHistory}
          setClientActivityHistory={setClientActivityHistory}
          setCommentActivityHistory={setCommentActivityHistory}
          setIsCfHistoryLoading={setIsCfHistoryLoading}
          setIsCommentsHistoryLoading={setIsCommentsHistoryLoading}
          setIsTnHistoryLoading={setIsTnHistoryLoading}
        />
      }
      {
        <ClientFilingTrackerDocuments
          show={showDocuments}
          dockAt="right"
          tracker={selectedTrackerCalendarEventExtract[0]}
          attachments={documents}
          handleClose={closeDocuments}
        />
      }
      {
        <ClientFilingConsolidatedUpdate
          show={showConsolidated}
          dockAt="right"
          cust={selectedTrackerCalendarEventDetails[0]}
          consolidatedRecords={consolidatedRecords}
          consolidatedStatus={consolidatedStatus}
          staffList={staffList}
          handleClose={closeConsolidated}
          selectedClientId={selectedClientId}
          handleRefreshTable={() => fetchCalendarEvents({}, true)}
          refreshConsList={() =>
            fetchConsolidatedRecords(selectedTrackerCalendarEventDetails[0])
          }
        />
      }
      {
        <CalendarDetailsDialog
          open={openCalendarDetails}
          handleClose={handleCalendarDetailsClose}
          filingDetails={selectedTrackerCalendarEventDetails[0]}
          refreshCalender={() =>
            fetchCalendarEvents(currentCalenderEvents, true)
          }
          currentCalendarYear={currentCalendarYear}
        />
      }
      <ClientFilingBulkStatusUpdate
        show={showBulkStatusDrawer}
        dockAt="right"
        statusRecords={selectedTrackerCalendarEventExtract}
        childList={bulkUpdateRecords}
        commonStaffs={commonStaffs}
        handleClose={closeStatusBulkUpdateDrawer}
        handleRefreshTable={() => fetchCalendarEvents({}, true)}
        selectedClientId={selectedClientId}
        selectedCustomer={selectedCustomer}
      // updateSelectedWorkflow={updateSelectedWorkflow}
      />
    </Fragment>
  );
};

export default TrackerCalendarView;
